<template>
  <van-uploader
    :fileList="fileList"
    accept="image/png, image/jpg, image/jpeg"
    multiple
    :max-count="5"
    :max-size="2 * 1024 * 1024"
    :before-read="handleBeforeRead"
    :after-read="handleAfterRead"
    @oversize="handleOversize"
    @delete="handleDelete"
  >
    <div class="van-uploader__upload">
      <van-icon name="plus" />
    </div>
  </van-uploader>
</template>

<script>
import { upload } from '@/api/common';
export default {
  name: 'UploadImage',
  data() {
    return {
      fileList: []
    }
  },
  watch: {
    fileList: {
      handler(newVal) {
        const url = newVal.map(item => item.url).join();
        this.$emit('uploadImage', url);
      },
      deep: true
    }
  },
  methods: {
    handleDelete(file) {
      // 删除文件
      this.fileList = this.fileList.filter(item => item.filename !== file.filename);
    },
    /**
     * 	文件读取前的回调函数，返回false可终止文件读取
     */
    handleBeforeRead(file) {
      const imgType = ['image/jpeg', 'image/png', 'image/jpg'];
      if (Array.isArray(file)) {
        file.forEach(item => {
          if (imgType.indexOf(item.type) === -1) {
            this.$toast('请上传图片');
            return false;
          }
        })
      } else if (imgType.indexOf(file.type) === -1) {
        this.$toast('请上传图片');
        return false;
      }
      return true;
    },
    /**
     * 文件读取完成后的回调函数
     */
    handleAfterRead(file) {
      if (Array.isArray(file)) { // 多图片上传
        const promiseList = file.map(item => this.uploadImage(item.file));
        Promise.all(promiseList)
          .then((res) => {
            this.fileList = res.map(item => item[0]);
          })
          .catch((err) => {
            this.$toast(err.message ? err.message : '上传失败');
            console.log(err);
          });
      } else {
        this.uploadImage(file.file).then((res) => {
          this.fileList = res;
        })
        .catch((err) => {
          this.$toast(err.message ? err.message : '上传失败');
          console.log(err);
        })
      }
    },
    /**
     * 上传图片
     */
    uploadImage(file) {
      return new Promise((resolve, reject) => {
        const formFileData = new FormData();
        formFileData.append('file', file);
        upload(formFileData).then(res => {
          if (res.errcode === 0) {
            // 上传成功
            resolve(res.data);
          } else {
            reject(res);
          }
        })
      });
    },
    handleOversize() {
      this.$toast('文件大小不能超过2M');
    }
  }
}
</script>

<style lang="less" scoped>

</style>